import styled from 'styled-components';
import { shade } from 'polished';

interface IButtonSwitcherProps {
  _hoverColor: string;
  _bgColor: string;
  _textColor: string;
}

export const Container = styled.button`
    background: #5D5D5D;
    height: 45px;
    border-radius: 4px;
    border: 0;
    color: #232129;
    width: 96%;
    font-weight: 500;
    margin-top: 10px;
    -webkit-transition: background-color 0.2s;
    transition: background-color 0.2s;
    font-size: 1rem;
    color: white;
    &:hover {
      background: ${shade(0.2, '#5D5D5D')};
    }
    background-color: ${(props: IButtonSwitcherProps) => props._bgColor};
    color: ${(props: IButtonSwitcherProps) => props._textColor};

    &:hover {
      cursor: pointer;
      color: ${props => props.theme.colors.white};
      background-color: ${(props: IButtonSwitcherProps) => props._hoverColor};
    }

    &:disabled {
      opacity: 0.5;
    }
`;